import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import cookie from 'react-cookies'

import api, { http } from 'lib/api'
import { Actions, logOut, actionLoadingName, actionSuccessName, actionErrorName } from 'state/actions'

const USER_ACCESS_TOKEN_COOKIE = 'token'

function* _async(actionType, method, ...params) {
  yield put({ type: actionLoadingName(actionType), ...params })
  try {
    const response = yield call(method, ...params)
    yield put({ type: actionSuccessName(actionType), response })
  } catch (error) {
    yield put({ type: actionErrorName(actionType), error })
  }
}

function* setupApp(action) {
  const token = cookie.load(USER_ACCESS_TOKEN_COOKIE)
  if (token) {
    yield updateApiTokenAndGetUser(token)
  }
}

// Remove cookie on 401
function* checkTokenValidity(action) {
  const { response } = action
  if (response && response.status) {
    if (response.status === 400 || response.status === 401) {
      yield put(logOut())
    }
  }
}

function* logIn(action) {
  yield _async(Actions.LOG_IN, api.logIn, action.payload)
}
function* setAccessToken(action) {
  // Get token and set on cookie
  const { access_token: token } = action.response.data
  cookie.save(USER_ACCESS_TOKEN_COOKIE, token)
  yield updateApiTokenAndGetUser(token)
}
function* updateApiTokenAndGetUser(token) {
  http.defaults.headers.common['Authorization'] = `Bearer ${token}`
  // Now get user
  yield _async(Actions.GET_USER, api.getUser)
}
function logUserOut(action) {
  // Pretty much it
  cookie.remove(USER_ACCESS_TOKEN_COOKIE)
}

function* getAgendas() {
  yield _async(Actions.GET_AGENDAS, api.getAgendas)
}

function* getAgendaReport(action) {
  yield _async(Actions.GET_AGENDA_REPORT, api.getAgendaReport, action.payload)
}
function* getAgendaWeekAppointments(action) {
  yield _async(Actions.GET_AGENDA_WEEK_APPOINTMENTS, api.getAgendaWeekAppointments, action.payload)
}
function* createAppointment(action) {
  yield _async(Actions.CREATE_APPOINTMENT, api.createAppointment, action.payload)
}
function* closeAppointment(action) {
  yield _async(Actions.CLOSE_APPOINTMENT, api.closeAppointment, action.payload)
}
function* closeAllAppointmentsForDay(action) {
  yield _async(Actions.CLOSE_ALL_APPOINTMENTS_FOR_DAY, api.closeAllAppointmentsForDay, action.payload)
}
function* openAppointment(action) {
  yield _async(Actions.OPEN_APPOINTMENT, api.openAppointment, action.payload)
}
function* completeAppointment(action) {
  yield _async(Actions.COMPLETE_APPOINTMENT, api.completeAppointment, action.payload)
}
function* cancelAppointment(action) {
  yield _async(Actions.CANCEL_APPOINTMENT, api.cancelAppointment, action.payload)
}

function* teleHealthAppointmentCredentials(action) {
   yield _async(Actions.GET_TELEHEALTH_APPOINTMENT_CREDENTIALS, api.getTeleHealthAppointmentCredentials, action.payload)
 }
 
function* sagas() {
  yield takeLatest(Actions.APP_START, setupApp)
  yield takeLatest('*', checkTokenValidity)
  yield takeLatest(Actions.LOG_IN, logIn)
  yield takeLatest(actionSuccessName(Actions.LOG_IN), setAccessToken) // On user log in success
  yield takeLatest(Actions.LOG_OUT, logUserOut)
  yield takeLatest(actionSuccessName(Actions.GET_USER), getAgendas)
  yield takeLatest(Actions.GET_AGENDAS, getAgendas) // Refresh agendas
  yield takeLatest(Actions.GET_AGENDA_REPORT, getAgendaReport)
  yield takeLatest(Actions.GET_AGENDA_WEEK_APPOINTMENTS, getAgendaWeekAppointments)
  yield takeEvery(Actions.CREATE_APPOINTMENT, createAppointment)
  yield takeEvery(Actions.CLOSE_APPOINTMENT, closeAppointment)
  yield takeEvery(Actions.CLOSE_ALL_APPOINTMENTS_FOR_DAY, closeAllAppointmentsForDay)
  yield takeEvery(Actions.OPEN_APPOINTMENT, openAppointment)
  yield takeEvery(Actions.COMPLETE_APPOINTMENT, completeAppointment)
  yield takeEvery(Actions.CANCEL_APPOINTMENT, cancelAppointment)
  yield takeLatest(Actions.GET_TELEHEALTH_APPOINTMENT_CREDENTIALS, teleHealthAppointmentCredentials)
}

export default sagas



// WEBPACK FOOTER //
// ./src/state/sagas.js